module.exports = __webpack_public_path__ + "img/footer5.26759645.png";